import Button from 'src/components/atoms/Button';
import styled from 'styled-components/macro';

export const StyledButton = styled(Button)`
  span[role='spinner'] {
    margin-left: 0;
  }
`;
